module.exports = __webpack_public_path__ + "static/media/icon-hospital.2ab83b86.svg";